import { connectAuthEmulator, getAuth } from "firebase/auth";
import app from "@/firebase/app";

const auth = getAuth(app);

if (process.env.VUE_APP_FIREBASE_EMULATORS === "TRUE") {
  connectAuthEmulator(auth, process.env.VUE_APP_FIREBASE_EMULATORS_AUTH, {
    disableWarnings: true,
  });
}

export default auth;
